export const GET_POSTS = "GET_POST"
export const GET_USER_POSTS = "GET_USER_POST"
export const GET_ALL_POSTS = "GET_ALL_POSTS"
export const CREATE_POST = "CREATE_POST"
export const GET_POST_WITH_ID = "GET_POST_WITH_ID"
export const DELETE_POST = "DELETE_POST"
export const UPDATE_POST = "UPDATE_POST"
export const LIKE = "LIKE"

export const AUTH = "AUTH"
export const LOGOUT = "LOGOUT"

export const STARTLOADING = "STARTLOADING"
export const ENDLOADING = "ENDLOADING"